<template>
    <div class="caozuoshouce">

      <div style="display: inline-block;">
          <el-button type="warning" :class="title?'shouceBtn':''" @click="openShiPin()" size="mini"> 操作视频 </el-button>
          <el-button type="danger" :class="title?'shouceBtn':''" @click="openShouCe()" size="mini">{{title?title:'操作手册'}}</el-button>
          <el-button type="danger" :class="title?'shouceBtn':''" @click="downloadChangJianWenTi()" size="mini">常见问题</el-button>
          <el-button type="danger" :class="title?'shouceBtn':''" @click="toZhiNengWenDa()" size="mini"> 智能问答 </el-button>
      </div>


        <div style="font-size: 16px;margin-left: 20px;color: #FFF;display: inline-block; line-height: 20px; ">
          <div style="display: flex; flex-direction: column;">
            <div>咨询电话：0311-88606635</div>
            <div>咨询时间(工作日)：8:30-12:00，14:30-17:30</div>
          </div>
        </div>


        <el-dialog title="手册列表" :visible.sync="shouceDialog" top="20px" width="480px" append-to-body>
          <div style="margin-left: 20px;">
            <div v-for="t in shouceList" :key="t.name" style="border-bottom: #cccccc 1px solid;">
              <div style="font-size: 18px;font-weight: 700;" v-html="t.name">

              </div>
              <div style="margin-left: 10px;">
                <template v-for="s in t.datas">
                  <el-row :key="s.name">
                   <el-col :span="12">
                     <el-link type="primary" size="mini" style="font-size: 16px;margin: 5px;" @click="downloadShouCe(s)"> {{s.name}} </el-link>
                   </el-col>
                    <el-col :span="5" v-if="s.videoUrl">
                         <el-button type="primary" size="mini" icon="el-icon-video-camera-solid" circle @click="toVideo(s.videoUrl)"></el-button>
                    </el-col>
                  </el-row>
                </template>
              </div>
            </div>
          </div>
        </el-dialog>

        <el-dialog title="操作视频列表" :visible.sync="shouceShiPin.dialog" top="20px" width="60%" append-to-body>
          <el-table :data="shouceShiPin.list">
            <el-table-column label="序号" type="index" :index="(index) => index + 1" width="50" align="center"></el-table-column>
             <el-table-column label="视 频（点击可查看）" prop="videoName">
                 <template #default="scope">
                    <el-link type="primary" size="mini" style="font-size: 16px;margin: 5px;" @click="toVideo(scope.row.videoUrl)"> {{scope.row.videoName}} </el-link>
                </template>
             </el-table-column>
             <el-table-column label="视频内容" prop="content"></el-table-column>
             <el-table-column label="相关操作手册（点击可查看）">
                <template #default="scope">
                  <div v-for="(sc, sIndex) in scope.row.shouCes" :key="'czsc-' + sIndex">
                    <el-link type="primary" size="mini" style="font-size: 16px;margin: 5px;" @click="downloadShouCe({name: sc})"> {{sc}} </el-link>
                  </div>
                </template>
             </el-table-column>
          </el-table>
        </el-dialog>
    </div>
</template>
<script>
    import baseUrl, {imageUrl} from "../constants";
    export default {
        props: ['title'],
        data() {
            return {
                screenHeight: document.documentElement.clientHeight, // 可见区域高度(应为body高度，可某些环境下无法获取)
                shouceDialog: false,
                shouceShiPin: {
                  dialog: false,
                  list: [
                    {videoName: '使用须知（必看）', videoUrl: '/public/video/%E4%BD%BF%E7%94%A8%E9%A1%BB%E7%9F%A5.mp4',  content: '介绍平台流程、使用前的准备工作', shouCes: ['1 系统使用环境.pdf']},
                    {videoName: '账号注册及登陆', videoUrl: '/public/video/%E8%B4%A6%E5%8F%B7%E6%B3%A8%E5%86%8C%E5%8F%8A%E7%99%BB%E5%BD%95.mp4',  content: '两类用户的注册、登陆方法；账号密码的找回操作', shouCes: ['2 单位注册.pdf', '3 个人注册.pdf', '4 用户登录.pdf']},
                    {videoName: '绑定申请及审核', videoUrl: '/public/video/%E7%BB%91%E5%AE%9A%E7%94%B3%E8%AF%B7%E5%8F%8A%E5%AE%A1%E6%A0%B8.mp4',  content: '两类用户注册完成后的绑定申请及审核', shouCes: ['5 绑定单位申请.pdf', '6 绑定单位审核.pdf']},
                    {videoName: '计量器具台账建立', videoUrl: '/public/video/%E8%AE%A1%E9%87%8F%E5%99%A8%E5%85%B7%E5%8F%B0%E8%B4%A6%E5%BB%BA%E7%AB%8B.mp4',  content: '两种添加方式：单个添加、批量倒入（选择一种即可），器具信息编辑修改', shouCes: ['7 计量器具台账.pdf']},
                    {videoName: '备案申请', videoUrl: '/public/video/%E5%A4%87%E6%A1%88%E7%94%B3%E8%AF%B7.mp4',  content: '备案申请操作、备案状态解读', shouCes: ['8 器具备案申请.pdf']},
                    {videoName: '检定申请', videoUrl: '/public/video/%E6%A3%80%E5%AE%9A%E7%94%B3%E8%AF%B7.mp4',  content: '检定申请操作、检定状态解读，“不受理”类型器具信息修改，单据导出，证书查看下载', shouCes: ['9 器具检定申请.pdf']},
                    {videoName: '再次报检操作', videoUrl: '/public/video/%E5%86%8D%E6%AC%A1%E6%8A%A5%E6%A3%80%E6%93%8D%E4%BD%9C.mp4',  content: '证书即将到期申请下一周期检定的操作', shouCes: []},
                  ]
                },

                shouceList: [
                  {name: "通用部分", datas: [
                      {name: "1 系统使用环境.pdf", url: ""},
                      {name: "2 单位注册.pdf", url: ""},
                      {name: "3 个人注册.pdf", url: ""},
                      {name: "4 用户登录.pdf", url: ""},
                      {name: "5 绑定单位申请.pdf", url: ""},
                      {name: "6 绑定单位审核.pdf", url: ""}]
                  },
                    {name: "企业部分", datas: [
                      {name: "7 计量器具台账.pdf", url: ""},
                      {name: "8 器具备案申请.pdf", url: ""},
                      {name: "9 器具检定申请.pdf", url: ""}]
                    },
                  {name: "行政部分<span style='color: red;font-size: 16px;'>（企业勿做）</span>", datas: [
                      {name: "10 基础设置（行政）.pdf", url: ""},
                      {name: "11 备案办理.pdf", url: ""}]
                  },
                  {name: "机构部分<span style='color: red;font-size: 16px;'>（企业勿做）</span>", datas: [
                      {name: "12 基础设置（机构）.pdf", url: ""},
                      {name: "13 检定办理.pdf", url: ""}]
                  },
                  {name: "诚信计量操作手册", datas: [
                      {name: "申报指南.pdf", url: "", videoUrl: '/public/video/%E8%AF%9A%E4%BF%A1%E8%AE%A1%E9%87%8F%E7%94%B3%E8%AF%B7%E5%8D%95%E4%BD%8D%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.mp4'}]
                  }
                ],
            }
        },
        methods: {
            openShiPin(){
              this.shouceShiPin.dialog = true;
            },
            //打开操作手册
            openShouCe(){
                this.shouceDialog = true;
            },
            downloadShouCe(row){
                if(row.name === '3 强检计量器具台账器具信息填写指南'){
                    console.log("123");
                }else{
                    window.open(baseUrl + "/file/download?file=/shoucePDF/" + row.name + "&name=" + row.name, '_blank');
                }
            },
            downloadChangJianWenTi(){
                window.open(baseUrl + "/file/download?file=/shoucePDF/常见问题解答（一）.pdf&name=常见问题解答（一）.pdf", '_blank');
            },
            downloadCaoZuoZhiYin(){
                window.open(baseUrl + "/file/download?file=/shoucePDF/计量业务应用平台-诚信计量申请单位用户操作指引.pdf&name=计量业务应用平台-诚信计量申请单位用户操作指引.pdf", '_blank');
            },
            toZhiNengWenDa(){
              window.open("https://www.hebjlzy.com/front/#/intelligentQa/toIntelligentQaIndex", '_blank');
            },
            toVideo(videoUrl){
              window.open(imageUrl + videoUrl);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .caozuoshouce {
      margin-left: 20px;
      float: left;
      text-align: left;
      white-space: pre-wrap;
      height: 78px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-end;
        .shouceBtn {
            border-style: outset;
            border-width: 3px;
            border-radius: 7px;
          height: 30px;
        }
    }
</style>
